<script>
// uses: /markets/agriculture
import * as tns from "tiny-slider/src/tiny-slider";
export default {
    mounted() {
        this.controls = this.$refs.sliderContols;
        this.setTabsAndFocus();
    },
    data() {
        return {
            currentMode: 'all',
            slideNum: 0,
            slider: null,
            contols: null,
        }
    },
    computed: {
        allShown() {
            return this.currentMode === 'all'
        },
        sliderMode() {
            return this.currentMode === 'slideshow'
        }
    },
    methods: {
        goToSlide(slideNum) {
            this.currentMode = 'slideshow'
            this.slideNum = slideNum
            if (!this.slider) {
                // console.log('dispatch slider')
                this.slider = tns({
                    container: this.$refs.sliderContainer,
                    lazyload: true,
                    prevButton: this.$refs.prevButton,
                    nextButton: this.$refs.nextButton,
                })
            } else {
                this.slider = this.slider.rebuild()
            }
            this.$nextTick(() => {
              this.slider.goTo(parseInt(slideNum))
            })
        },
        backToAll() {
            this.sliderNum = 0;
            this.currentMode = 'all';
            this.slider.destroy();
            this.$nextTick(() => {
                this.setTabsAndFocus(true);
            })
            
        },
        setTabsAndFocus(isBack = false) {
            const w = window.innerWidth;
            if (w <= 768) {
                this.$refs.mobileAll.setAttribute('tabindex', 0);
                if (isBack) {
                    this.$refs.mobileAll.focus();
                }
            } else {
                this.$refs.mobileAll.setAttribute('tabindex', -1);
                if (isBack) {
                    this.$refs.first.focus();
                }
            }
        }
    },
}
</script>